import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Shortener from "../pages/Shortener";
import MyLinkTree from "../pages/MyLinkTree";
import WifiQrPage from "../pages/WifiQrPage";
import "../../styles/Workspace.css";

import LinkHubLogo from "../../assets/images/LinkHub-Logo.svg";
import WiFyLogo from "../../assets/images/Wi-Fy-Logo.svg";
import ShortenLogo from "../../assets/images/Shorten-Logo.svg";

interface FeatureTab {
  id: string;
  logo: string;
  label: string;
  component: React.ComponentType;
}

const FEATURES: FeatureTab[] = [
  {
    id: "shortener",
    logo: ShortenLogo,
    label: "Shortener",
    component: Shortener,
  },
  {
    id: "linkhub",
    logo: LinkHubLogo,
    label: "LinkHub",
    component: MyLinkTree,
  },
  {
    id: "wify",
    logo: WiFyLogo,
    label: "Wi-Fy",
    component: WifiQrPage,
  },
];

export const Workspace: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "shortener";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  useEffect(() => {
    const tab = searchParams.get("tab") || "shortener";
    setActiveTab(tab);
  }, [searchParams]);

  const handleTabChange = (featureId: string) => {
    setActiveTab(featureId);
    setSearchParams({ tab: featureId });
  };

  return (
    <div className="workspace">
      <div className="workspace-tabs">
        {FEATURES.map((feature) => (
          <button
            key={feature.id}
            className={`workspace-tab ${
              activeTab === feature.id ? "active" : ""
            }`}
            onClick={() => handleTabChange(feature.id)}
          >
            <img
              src={feature.logo}
              alt={feature.label}
              className="workspace-tab-icon"
            />
            <span className="workspace-tab-label">{feature.label}</span>
          </button>
        ))}
      </div>

      <div className="workspace-content">
        <div
          className={`workspace-panel ${
            activeTab === "shortener" ? "active" : ""
          }`}
        >
          <Shortener />
        </div>
        <div
          className={`workspace-panel ${
            activeTab === "linkhub" ? "active" : ""
          }`}
        >
          <MyLinkTree />
        </div>
        <div
          className={`workspace-panel ${activeTab === "wify" ? "active" : ""}`}
        >
          <WifiQrPage />
        </div>
      </div>
    </div>
  );
};

export default Workspace;
